// handle sharer click
export function registerSharing() {
  const copyBtns = document.getElementsByClassName("btn-copy");
  for (let copyBtn of copyBtns) {
    copyBtn.addEventListener("click", (e) => {
      copy(copyBtn.dataset.url);
    });
  }

  const downloadBtns = document.getElementsByClassName("btn-download");
  for (let downloadBtn of downloadBtns) {
    downloadBtn.addEventListener("click", (e) => {
      download(downloadBtn.parentNode, downloadBtn.dataset.media, downloadBtn.dataset.name);
    });
  }

  // track sharing data
  const btns = document.getElementsByClassName("btn-sharing-event");
  for (const btn of btns) {
    btn.addEventListener("click", () => {
      const medium = btn.dataset.type;
    });
  }
}

// copy
function copy(url) {
  const el = document.createElement("textarea");
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  el.value = `https://memsekcja.pl${url}?ref=copy`;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
}

// download
function download(parent, media, slug) {
  var link = document.createElement("a");

  fetch(`https://memy.memsekcja.pl/${media}`)
    .then((res) => res.blob())
    .then((blob) => {
      let mediaPath = media.split(".");
      let name = slug + ".memsekcja." + mediaPath[mediaPath.length - 1];

      link.setAttribute("href", URL.createObjectURL(blob));
      link.setAttribute("download", name);
      parent.appendChild(link);
      link.click();
      parent.removeChild(link);
    });
}
